// import { getSession } from '@/utils';

import { removeToken,getToken, setToken } from '@/utils/auth'

const config = {
  baseURL: 'https://pcapi.shadowmaths.com',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    // 'ssotoken': sessionStorage.getItem('token')//getToken()
    // 'ssotoken': getToken()
  },
  // 自定义全局请求头
  headerHandlers: [
    () => new Promise((resolve) => {
      const ssotoken = localStorage.getItem('token');//getSession('userInfo');
      // resolve({'session': userInfo ? userInfo.session : ''});
      resolve({'ssotoken':ssotoken});
    })
  ],
}

export default config;



// WEBPACK FOOTER //
// ./src/request/config.js